import { ExternalMedia } from './external-media';
import { Tonnage } from './tonnage';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateSiteCommand {
  SiteId: string;
  SiteName: string;
  SiteReference: string;
  SiteAddress: string;
  Latitude: number;
  Longitude: number;
  SiteStatusId: string;
  SiteDepotId: string;
  SiteImage: ExternalMedia;
  StaffId: string;
  AddStaffToSite: boolean;
  DefaultSiteAreaId: string;
  DefaultSiteAreaName: string;
  IsCameraAllowed: boolean;
  IsManageStockControl: boolean;
  SiteSetupFrom: number;
  Tonnages: Tonnage[];
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


